import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Button, Form, Input, message
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import { useTranslation } from 'react-i18next';
import * as Service from '../core/Service';

const NewsForm = (props) => {
  const {t} = useTranslation();

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const {
    selectedRecord,
    openModal
  } = props;

  useEffect(() => {
    console.log('reset data')
    form.resetFields();
    console.log('setting data', selectedRecord)
    setFormData(selectedRecord);
  }, [form, selectedRecord]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [form, formData]);

  const onFinish = async (formObj) => {
    let method = `POST`;
    let endpoint = `/api/trafficnews`;

    console.log("trafficnews_id", formData.trafficnews_id);
    let bodyObj = _.clone(formObj);
    if (formData.trafficnews_id > 0) {
      bodyObj.trafficnews_id = formData.trafficnews_id;
      method = `PUT`;
    }

    try {
      let resp = await Service.call(method, endpoint, bodyObj);
      if (resp.errorMessage) {
        message.error(resp.errorMessage);
        return;
      }
      message.success(t('common.success'));
      return openModal(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFinish={onFinish}
      initialValues={formData}
    >
      <Form.Item
        name="trafficnews_title"
        label={t('common.title')}
        rules={[{ required: true, message: `${t('common.please_input')}` }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="trafficnews_content"
        label={t('common.content')}
        rules={[{ required: true, message: `${t('common.please_input')}` }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
        >
          {t('common.submit')}
        </Button>
      </Form.Item>
    </Form >
  );
}

export default NewsForm;
